import React, { Suspense, lazy, useEffect } from "react";
import { Route, Switch } from "react-router";
import { connect } from "react-redux";
import lazyRetry from "./helpers/lazyRetry";
import withLayout from "./components/common/base";
import Auth from "./components/auth";
import CustomLoader from "./components/common/loader";
import idleTimeTracker from "./helpers/idleTimeTracker";
import { ROLE } from "./helpers/constants";
import { getSignOut } from "./helpers/api/api.js";

const Notifications = lazy(() =>
  lazyRetry(() => import("./components/common/notifications"), "notifications")
);
const GlobalSearch = lazy(() =>
  lazyRetry(() => import("./components/common/globalSearch"), "globalSearch")
);
const ContactUs = lazy(() =>
  lazyRetry(() => import("./components/contactUs/contactUs"), "contactUs")
);
const licenses = lazy(() =>
  lazyRetry(() => import("./components/licenses/index"), "licenses")
);
const cateWiseCourseList = lazy(() =>
  lazyRetry(
    () => import("./components/course/courseCategory/cateWiseCourseList"),
    "cateWiseCourseList"
  )
);
const DiscussionDetail = lazy(() =>
  lazyRetry(
    () => import("./components/discussions/discussionDetail"),
    "DiscussionDetail"
  )
);

const AssessmentName = lazy(() =>
  lazyRetry(
    () => import("./components/assessment/learner/Assessement/AssessmentName"),
    "AssessmentName"
  )
);

const SocialWallRoutes = lazy(() =>
  lazyRetry(
    () => import("./components/socialWall/socialWallRoutes"),
    "socialWallRoutes"
  )
);
const ReviewList = lazy(() =>
  lazyRetry(() => import("./components/dashboard/reviewList"), "reviewList")
);

const Dashboard = lazy(() =>
  lazyRetry(() => import("./components/dashboard/"), "dashboard")
);

const PlagiarismTool = lazy(() =>
  lazyRetry(() => import("./components/plagiarismTool"), "plagiarismTool")
);

const ApprovalWorkFlow = lazy(() =>
  lazyRetry(() => import("./components/approvalWorkFlows"), "approvalWorkFlows")
);

const Requests = lazy(() =>
  lazyRetry(() => import("./components/requests"), "requests")
);

const Certificate = lazy(() =>
  lazyRetry(() => import("./components/certificate"), "certificate")
);

const Customtest = lazy(() =>
  lazyRetry(() => import("./components/dashboard"), "customtest")
);

const Feedback = lazy(() =>
  lazyRetry(() => import("./components/feedback"), "feedback")
);

const Course = lazy(() =>
  lazyRetry(() => import("./components/course/"), "course")
);
const AllCourse = lazy(() =>
  lazyRetry(
    () => import("./components/course/courseList/allCourses"),
    "allCourses"
  )
);

const CourseDetail = lazy(() =>
  lazyRetry(() => import("./components/course/courseDeatil/"), "CourseDetail")
);

const Events = lazy(() =>
  lazyRetry(() => import("./components/events/"), "events")
);

const CustomerListView = lazy(() =>
  lazyRetry(() => import("./components/adminDashboard/index"), "admiDashboard")
);

const Profile = lazy(() =>
  lazyRetry(() => import("./components/profile/index"), "profile-index")
);
const MyProfile = lazy(() =>
  lazyRetry(() => import("./components/profile/myprofile"), "profile-myprofile")
);
const Support = lazy(() =>
  lazyRetry(() => import("./components/contactUs/contactUs"), "contactUs")
);

const AdminLearning = lazy(() =>
  lazyRetry(
    () => import("./components/learningPathDemo/index"),
    "admiDashboard"
  )
);
const LearningPath = lazy(() =>
  lazyRetry(
    () => import("./components/learningPath/index"),
    "learningPath-index"
  )
);

const Signin = lazy(() =>
  lazyRetry(() => import("./components/signin/"), "signin")
);

const NotFound = lazy(() =>
  lazyRetry(() => import("./components/common/notFound"), "notFound")
);
const Signup = lazy(() =>
  lazyRetry(() => import("./components/signup/"), "signup")
);
const VerifyEmail = lazy(() =>
  lazyRetry(() => import("./components/signup/verifyEmail"), "verifyEmail")
);
const RecoverAccount = lazy(() =>
  lazyRetry(
    () => import("./components/signin/recoverAccount"),
    "recoverAccount"
  )
);
const PasswordForgotten = lazy(() =>
  lazyRetry(
    () => import("./components/signin/passwordForgotten"),
    "passwordForgotten"
  )
);
const PasswordForgottenOtp = lazy(() =>
  lazyRetry(
    () => import("./components/signin/passowrdResetmobile"),
    "passowrdResetmobile"
  )
);
const PasswordReset = lazy(() =>
  lazyRetry(() => import("./components/signin/passwordReset"), "passwordReset")
);
const AddCourse = lazy(() =>
  lazyRetry(() => import("./components/course/admin/addCourse.js"), "addCourse")
);
const editCourseAdmin = lazy(() =>
  lazyRetry(
    () => import("./components/course/admin/editCourseAdmin.js"),
    "editCourseAdmin"
  )
);
const CategoryDetail = lazy(() =>
  lazyRetry(
    () => import("./components/course/courseCategory/categoryDetail"),
    "categoryDetail"
  )
);
const MediaDetail = lazy(() =>
  lazyRetry(
    () => import("./components/course/courseCategory/mediaDetail"),
    "mediaDetail"
  )
);
const AddCourseModule = lazy(() =>
  lazyRetry(
    () => import("./components/course/admin/courseModule"),
    "courseModule"
  )
);
const CourseFaq = lazy(() =>
  lazyRetry(() => import("./components/course/admin/courseFaq"), "courseFaq")
);
const CourseReview = lazy(() =>
  lazyRetry(
    () => import("./components/course/admin/courseReview"),
    "courseReview"
  )
);

const Assessment = lazy(() =>
  lazyRetry(() => import("./components/assessment"), "assessment")
);
const AttemptedSubjects = lazy(() =>
  lazyRetry(
    () => import("./components/assessment/admin/attemptedSubjects"),
    "attemptedSubjects"
  )
);
const AttemptedUserDetails = lazy(() =>
  lazyRetry(
    () => import("./components/assessment/admin/attemptedUserDetails"),
    "attemptedUserDetails"
  )
);
const AsssesmentResults = lazy(() =>
  lazyRetry(
    () => import("./components/assessment/admin/asssesmentResults"),
    "asssesmentResults"
  )
);
const EditAssessment = lazy(() =>
  lazyRetry(
    () => import("./components/assessment/editAssessment"),
    "editAssessment"
  )
);
const QuestionBank = lazy(() =>
  lazyRetry(
    () => import("./components/assessment/questionBank"),
    "questionBank"
  )
);

const Leaderboard = lazy(() =>
  lazyRetry(() => import("./components/leaderboard"), "leaderboard")
);

const ProfileDetails = lazy(() =>
  lazyRetry(
    () => import("./components/leaderboard/admin/profileDetails"),
    "profileDetails"
  )
);
const Announcements = lazy(() =>
  lazyRetry(() => import("./components/announcements"), "announcements")
);

const Discussions = lazy(() =>
  lazyRetry(() => import("./components/discussions"), "discussions")
);
const ClassRoom = lazy(() =>
  lazyRetry(() => import("./components/addClassrooms"), "addClassrooms")
);
const AddClassRoom = lazy(() =>
  lazyRetry(
    () => import("./components/addClassrooms/AddClassRoom"),
    "AddClassRoom"
  )
);
const ClassRoomAddSession = lazy(() =>
  lazyRetry(
    () => import("./components/classroom/classroomTrainer/session"),
    "session"
  )
);
const ClassRoomAttendees = lazy(() =>
  lazyRetry(
    () => import("./components/classroom/detailedAttendees"),
    "detailedAttendees"
  )
);
const Reports = lazy(() =>
  lazyRetry(() => import("./components/reports"), "reports")
);
const DownloadReport = lazy(() =>
  lazyRetry(
    () => import("./components/downloadReport/DownloadReport"),
    "downloadReport"
  )
);
const CPD = lazy(() => lazyRetry(() => import("./components/cpd/cpd"), "cpd"));

const CPDView = lazy(() =>
  lazyRetry(() => import("./components/cpd/CPDView"), "cpdView")
);

const Competency = lazy(() =>
  lazyRetry(() => import("./components/competency"), "competency")
);

const AllCoursesList = lazy(() =>
  lazyRetry(
    () => import("./components/course/courseCategory/allCoursesList"),
    "allCoursesList"
  )
);
const CourseList = lazy(() =>
  lazyRetry(
    () => import("./components/course/courseList/courseList"),
    "courseList"
  )
);
const Assigned = lazy(() =>
  lazyRetry(
    () => import("./components/course/courseCategory/assigned"),
    "assigned"
  )
);
const unAssigned = lazy(() =>
  lazyRetry(
    () => import("./components/course/courseCategory/unAssigned"),
    "unAssigned"
  )
);
const AllAssignList = lazy(() =>
  lazyRetry(
    () => import("./components/course/courseCategory/allAssignList"),
    "allAssignList"
  )
);
const AddDialog = lazy(() =>
  lazyRetry(
    () => import("./components/course/admin/courseModule/addModule"),
    "addModule"
  )
);
const LearningCourse = lazy(() =>
  lazyRetry(
    () => import("./components/learningPath/learningCourse"),
    "learningCourse"
  )
);
const AnnouncementsDetail = lazy(() =>
  lazyRetry(
    () => import("./components/announcements/announcementsDetail"),
    "announcementsDetail"
  )
);
const ProctorOld = lazy(() =>
  lazyRetry(() => import("./components/proctor"), "proctor")
);
const Proctor = lazy(() =>
  lazyRetry(
    () => import("./components/assessment/proctor"),
    "assessment-proctor"
  )
);

function withLoader(Component) {
  return (props) => (
    <Suspense fallback={<CustomLoader />}>
      <Component {...props} />
    </Suspense>
  );
}

const Routes = ({ session }) => {
  function withPermissions(Component, allowedUserRoles = []) {
    const isAllowed = allowedUserRoles.includes(session?.membership?.role?.id);
    return isAllowed ? withLoader(Component) : withLoader(NotFound);
  }

  const handleLogg = async () => {
    await getSignOut();
  };
  const callBackIdleTimer = () => {
    handleLogg();
    localStorage.removeItem("token");
    localStorage.setItem(
      "lastActiveModule",
      window.location.pathname.split("/")[1]
    );
    localStorage.removeItem("decryptKey");
    window.history.replaceState(null, "", "/");
    window.location.href = "/";
  };

  useEffect(() => {
    const idleTimer = idleTimeTracker({
      callBack: callBackIdleTimer,
      IdleTimeOut: 30,
      message: "",
      showAlert: false,
    });
    return () => {
      idleTimer.removeIdleTimer();
    };
  }, []);

  const managerRole = [
    parseInt(ROLE.superadmin),
    parseInt(ROLE.admin),
    parseInt(ROLE.trainer),
  ];

  const modulePermissions = session?.profile?.permissions;

  //console.log("all permissions", modulePermissions);

  const permissionsData = [];

  if (typeof modulePermissions !== "undefined") {
    const parsedData = JSON.parse(modulePermissions);
    for (var i in parsedData) {
      if (parsedData[i].permission) {
        permissionsData.push(parsedData[i].href);
      }
    }
  }

  //console.log("permissionsData", permissionsData);

  return (
    <Switch>
      <Route exact path="/" component={withLayout(withLoader(Signin))} />
      <Route exact path="/login" component={withLayout(withLoader(Signin))} />
      <Route exact path="/signup" component={withLayout(withLoader(Signup))} />
      <Route
        exact
        path="/verify-email/:uid/:token"
        component={withLayout(withLoader(VerifyEmail))}
      />
      <Route
        exact
        path="/password/reset/confirm/:uid/:token"
        component={withLayout(withLoader(PasswordReset))}
      />
      <Route
        exact
        path="/password/reset/"
        component={withLayout(withLoader(PasswordForgotten))}
      />
      <Route
        exact
        path="/password/reset/Otp/"
        component={withLayout(withLoader(PasswordForgottenOtp))}
      />
      <Route
        exact
        path="/password/recover"
        component={withLayout(withLoader(RecoverAccount))}
      />

      {/* Without API's  */}
      <Auth path="/support" component={withLoader(Support)} />
      <Auth path="/certificate" component={withLoader(Certificate)} />
      <Auth path="/customtest" component={withLoader(Customtest)} />
      <Auth path="/feedback" component={withLoader(Feedback)} />
      <Auth path="/requests" component={withLoader(Requests)} />
      <Auth path="/dashboard" component={withLoader(Dashboard)} />
      <Auth path="/reviewlist" component={withLoader(ReviewList)} />
      <Auth path="/notifications" component={withLoader(Notifications)} />
      <Auth path="/search" component={withLoader(GlobalSearch)} />
      <Auth path="/contactUs" component={withLoader(ContactUs)} />
      <Auth path="/myprofile" component={withLoader(MyProfile)} />
      <Auth path="/licenses" component={withLoader(licenses)} />

      {/* Without API's ends  */}

      <Auth
        path="/socialwall"
        component={withLoader(SocialWallRoutes)}
        isPermitted={modulePermissions?.includes("/socialwall")}
      />

      <Auth
        exact
        path="/organization"
        component={withLoader(CustomerListView)}
        isPermitted={modulePermissions?.includes("/organization")}
      />
      <Auth
        path="/organization/profile/:id"
        component={withLoader(Profile)}
        isPermitted={modulePermissions?.includes("/organization")}
      />
      <Auth
        exact
        path="/learning-path"
        component={withLoader(AdminLearning)}
        isPermitted={modulePermissions?.includes("/learning-path")}
      />
      <Auth
        path="/calendar"
        component={withLoader(Events)}
        isPermitted={modulePermissions?.includes("/calendar")}
      />
      <Auth
        path="/courses/all-courses"
        component={withLoader(AllCourse)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        exact
        path="/courses"
        component={withLoader(Course)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth path="/course-module/:id" component={withLoader(AddCourseModule)} />
      <Auth
        path="/courses/course-detail/:id"
        component={withLoader(CourseDetail)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/courses/add-course"
        component={withPermissions(AddCourse, managerRole)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/assessment/results/:id"
        component={withLoader(AsssesmentResults)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      <Auth
        exact
        path="/courses/edit-course/:id"
        component={withPermissions(editCourseAdmin, managerRole)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/courses/edit-course-cate/:id"
        component={withPermissions(editCourseAdmin, managerRole)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/courses/course-category-detail"
        component={withPermissions(CategoryDetail, managerRole)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/courses/course-media-detail/:type"
        component={withPermissions(MediaDetail, managerRole)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/courses/course-faq/:id"
        component={withPermissions(CourseFaq, managerRole)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/courses/course-review/:id"
        component={withPermissions(CourseReview, managerRole)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        exact
        path="/assessment"
        component={withLoader(Assessment)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />

      <Auth
        path="/assessment/result/:id"
        component={withLoader(AttemptedUserDetails)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      <Auth
        path="/assessment/review"
        component={withPermissions(AttemptedSubjects, managerRole)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      <Auth
        path="/assessment/edit-assessment/:id"
        component={withLoader(EditAssessment)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      <Auth
        path="/assessment/question-bank"
        component={withPermissions(QuestionBank, managerRole)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      <Auth path="/leaderboard" exact component={withLoader(Leaderboard)} />
      <Auth path="/leaderboard/:id" component={withLoader(ProfileDetails)} />

      <Auth
        exact
        path="/announcements"
        component={withLoader(Announcements)}
        isPermitted={modulePermissions?.includes("/announcements")}
      />
      <Auth
        exact
        path="/discussions"
        component={withLoader(Discussions)}
        isPermitted={modulePermissions?.includes("/discussions")}
      />

      <Auth
        path="/reports"
        component={withLoader(Reports)}
        isPermitted={modulePermissions?.includes("/reports")}
      />
      <Auth
        path="/download-report/:id"
        component={withLoader(DownloadReport)}
        isPermitted={modulePermissions?.includes("/reports")}
      />
      <Auth
        path="/cpd"
        component={withLoader(CPD)}
        isPermitted={modulePermissions?.includes("/cpd")}
      />
      <Auth
        path="/cpd-view/:uid"
        component={withLoader(CPDView)}
        isPermitted={modulePermissions?.includes("/cpd")}
      />

      <Auth
        path="/competency"
        component={withLoader(Competency)}
        isPermitted={modulePermissions?.includes("/competency")}
      />

      <Auth
        path="/classroom"
        exact
        component={withLoader(ClassRoom)}
        isPermitted={modulePermissions?.includes("/classroom")}
      />

      <Auth
        path="/classroom/classes"
        exact
        component={withLoader(AddClassRoom)}
        isPermitted={modulePermissions?.includes("/classroom")}
      />
      <Auth
        path="/classroom/classes/edit"
        exact
        component={withLoader(AddClassRoom)}
        isPermitted={modulePermissions?.includes("/classroom")}
      />
      <Auth
        path="/classroom/add-session"
        component={withLoader(ClassRoomAddSession)}
        isPermitted={modulePermissions?.includes("/classroom")}
      />

      <Auth
        path="/classroom/attendees/:id"
        component={withLoader(ClassRoomAttendees)}
        isPermitted={modulePermissions?.includes("/classroom")}
      />
      <Auth
        path="/courses/admin-all-course-detail"
        component={withLoader(AllCoursesList)}
        isPermitted={modulePermissions?.includes("/courses")}
      />

      <Auth
        exact
        path="/course/:id"
        component={withPermissions(CourseList, managerRole)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/asssigned_course"
        component={withLoader(Assigned)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/unasssigned_course"
        component={withLoader(unAssigned)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        exact
        path="/courses/category_course_list/:id"
        component={withLoader(cateWiseCourseList)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/all_assigned_courses_list/:id"
        component={withLoader(AllAssignList)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/courses/module/:id"
        component={withLoader(AddDialog)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        exact
        path="/learning-path/:id"
        component={withLoader(LearningPath)}
        isPermitted={modulePermissions?.includes("/learning-path")}
      />
      <Auth
        exact
        path="/discussions/:id"
        component={withLoader(DiscussionDetail)}
        isPermitted={modulePermissions?.includes("/discussions")}
      />
      <Auth
        exact
        path="/learning-path/learner/learning-path/:id"
        component={withLoader(LearningCourse)}
        isPermitted={modulePermissions?.includes("/learning-path")}
      />
      <Auth
        exact
        path="/assessment/start"
        component={withLoader(AssessmentName)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />

      <Auth
        path="/announcements/:id/"
        component={withLoader(AnnouncementsDetail)}
        isPermitted={modulePermissions?.includes("/announcements")}
      />
      <Auth
        path="/assessment/:id/proctor/"
        exact
        component={withLoader(Proctor)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      <Auth
        path="/assessment/:id/proctor-view-card/:groupId"
        exact
        component={withLoader(Proctor)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      <Auth
        path="/assessment/:id/proctor-view-card/:groupId/:evidence"
        exact
        component={withLoader(Proctor)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      <Auth
        exact
        path="/assessment/:uuid"
        component={withLoader(AssessmentName)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      <Auth
        path="/assessment/proctor-view-old"
        exact
        component={withLoader(ProctorOld)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      <Auth
        path="/plagiarism"
        component={withLoader(PlagiarismTool)}
        isPermitted={modulePermissions?.includes("/plagiarism")}
      />
      <Auth
        path="/settings"
        component={withLoader(ApprovalWorkFlow)}
        isPermitted={modulePermissions?.includes("/settings")}
      />

      <Route path="*" component={withLoader(NotFound)} />
    </Switch>
  );
};

const mapStateToProps = (state) => ({
  session: state.session,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
